import React, { FC, useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper, alpha, useTheme } from '@mui/material';
import { MdHistoryToggleOff, MdOutlineFormatListBulleted } from 'react-icons/md';
import { PrazosFluxosHCP } from './PrazosFluxos/index';
import { ProductionTypesHCP } from './ProductionTypes/index';

const ConfiguracoesHCP: FC = () => {
  const theme = useTheme();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ p: 4, maxWidth: 1600, mx: 'auto' }}>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <Box>
          <Typography variant="h3" fontWeight={900} color="text.primary" sx={{ letterSpacing: -1.5, mb: 1 }}>
            Painel de Configurações
          </Typography>
          <Typography variant="body1" color="text.secondary" fontWeight={500}>
            Ajuste os parâmetros operacionais do Hub de Produção e prazos do Frete Hero.
          </Typography>
        </Box>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: alpha(theme.palette.divider, 0.1), mb: 4 }}>
        <Tabs 
          value={tabIndex} 
          onChange={handleTabChange}
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 700,
              fontSize: '1rem',
              minHeight: 56,
              mr: 4,
              transition: 'all 0.2s',
              color: 'text.secondary',
              opacity: 0.7,
              '&.Mui-selected': {
                color: theme.palette.primary.main,
                opacity: 1
              },
              '&:hover': {
                color: theme.palette.primary.main,
                opacity: 0.9
              }
            },
            '& .MuiTabs-indicator': {
              height: 4,
              borderRadius: '4px 4px 0 0',
              backgroundColor: theme.palette.primary.main
            }
          }}
        >
          <Tab icon={<MdHistoryToggleOff size={22} />} iconPosition="start" label="Prazos e Fluxos" />
          <Tab icon={<MdOutlineFormatListBulleted size={22} />} iconPosition="start" label="Tipos de Produção" />
          <Tab icon={<MdOutlineFormatListBulleted size={22} />} iconPosition="start" label="Logs de Sincronização" disabled />
        </Tabs>
      </Box>

      <Box>
        {tabIndex === 0 && (
          <Box sx={{ 
            animation: 'fadeIn 0.3s ease-out',
            '@keyframes fadeIn': {
              from: { opacity: 0, transform: 'translateY(10px)' },
              to: { opacity: 1, transform: 'translateY(0)' }
            }
          }}>
            <PrazosFluxosHCP />
          </Box>
        )}

        {tabIndex === 1 && (
          <Box sx={{ 
            animation: 'fadeIn 0.3s ease-out',
            '@keyframes fadeIn': {
              from: { opacity: 0, transform: 'translateY(10px)' },
              to: { opacity: 1, transform: 'translateY(0)' }
            }
          }}>
            <ProductionTypesHCP />
          </Box>
        )}
        
        {tabIndex === 2 && (
          <Paper sx={{ 
            p: 8, 
            textAlign: 'center', 
            borderRadius: 6, 
            bgcolor: alpha(theme.palette.primary.main, 0.01), 
            border: '2px dashed', 
            borderColor: alpha(theme.palette.divider, 0.1) 
          }}>
            <Typography variant="h6" fontWeight={700} color="text.secondary" sx={{ mb: 1 }}>Histórico em Breve</Typography>
            <Typography variant="body2" color="text.disabled">Estamos preparando uma visualização detalhada de todas as sincronizações.</Typography>
          </Paper>
        )}
      </Box>
    </Box>
  );
};

export default ConfiguracoesHCP;
